import * as React from 'react';
import {
  Button,
  HStack,
  Spacer,
  Text,
  TextInput,
  View,
  VStack,
} from '@packages/systems/spring';
import {validateUrl} from '@packages/shared/utils/UrlUtils';

const NEW_WEBHOOK_PLACEHOLDER_TEXT = 'https://domain.com/webhook/webflow';

type NewWebhookInputProps = {
  onWebhookSave: (url: string) => void;
  close: () => void;
};
const NewWebhookInput = ({onWebhookSave, close}: NewWebhookInputProps) => {
  const [webhookInput, setWebhookInput] = React.useState<string>('');
  const [errorText, setErrorText] = React.useState<string | null>('');

  const handleWebhookSave = React.useCallback(() => {
    const error = validateUrl(webhookInput);
    setErrorText(error);
    if (error) {
      return;
    }

    onWebhookSave(webhookInput);
    close();
  }, [onWebhookSave, webhookInput, close]);

  return (
    <View padding="$2">
      <VStack isFullHeight>
        <Text colorVariant="dimmed">Webhook URL</Text>
        <TextInput
          value={webhookInput}
          onChange={(e) => setWebhookInput(e.target.value)}
          placeholder={NEW_WEBHOOK_PLACEHOLDER_TEXT}
          type="url"
          data-automation-id="new-webhook-url-input"
        />
        <Text hidden={!errorText} font="helpText" colorVariant="danger">
          {errorText}
        </Text>
        <Spacer hidden={Boolean(errorText)} />
        <HStack isFullWidth={false} justify="end">
          <Button colorVariant="primary" onClick={handleWebhookSave}>
            Save
          </Button>
        </HStack>
      </VStack>
    </View>
  );
};

export default NewWebhookInput;
